// extracted by mini-css-extract-plugin
module.exports = {"heroImage":"_19MKN","container":"_2syvp"};